export default __webpack_public_path__ + "static/media/joshua-schachter.93f5a75b.jpg";